import React from "react";
import SendMeEther from "../assets/portfolio/SendMeEther.png";
import weatherApp from "../assets/portfolio/weatherApp.png";
import adviceGenerator from "../assets/portfolio/adviceGenerator.png";

const Portfolio = () => {
  return (
    <div name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen">

      <div  className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">

        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">Portfolio</p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">

        <div className="shadow-md shadow-gray-600 rounded-lg">
          <img src={SendMeEther} alt=""  className="rounded-md duration-200 hover:scale-105" />
          <div className="flex items-center justify-center">
            <button  className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
              <a href="https://singular-croquembouche-8e2787.netlify.app" target="_blank" rel="noreferrer">Demo</a> 
            </button>
            <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" >
              <a href="https://github.com/NishantSeth14/Web3.0" target="_blank" rel="noreferrer">Code</a> 
            </button>
          </div>
        </div>

        <div className="shadow-md shadow-gray-600 rounded-lg">
          <img src={weatherApp} alt=""  className="rounded-md duration-200 hover:scale-105" />
          <div className="flex items-center justify-center">
            <button  className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
              <a href="http://radiant-semifreddo-c0bb7d.netlify.app" target="_blank" rel="noreferrer">Demo</a> 
            </button>
            <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" >
              <a href="https://github.com/NishantSeth14/news_application" target="_blank" rel="noreferrer">Code</a> 
            </button>
          </div>
        </div>

        <div className="shadow-md shadow-gray-600 rounded-lg">
          <img src={adviceGenerator} alt=""  className="rounded-md duration-200 hover:scale-105" />
          <div className="flex items-center justify-center">
            <button  className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
              <a href="https://adorable-squirrel-963472.netlify.app" target="_blank" rel="noreferrer">Demo</a> 
            </button>
            <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" >
              <a href="https://github.com/NishantSeth14/quote_generator" target="_blank" rel="noreferrer">Code</a> 
            </button>
          </div>
        </div>

        </div>




      </div>

    </div>
  );
};

export default Portfolio;